@import 'styles/mixins';
@import 'styles/variables';
@import 'styles/blaze/mixins';

.container {
  box-shadow: 1px 1px 0px 0px rgba(255, 255, 255, 0.9) inset, 0px 2px 12px 0px rgba(0, 0, 0, 0.04);
  backdrop-filter: blur(35px);
  border-radius: 0px 0px 10px 10px;
  padding: 20px;
  border-top: 4px solid var(--plan-color);
}

.icon {
  margin-right: 10px;
  height: 25px;
  color: var(--plan-color);
}

.headerContainer {
  display: flex;
  justify-content: space-between;
  & h2 {
    font-family: Sohne;
    font-size: 26px;
    font-style: normal;
    font-weight: 600;
    line-height: 110%;
    letter-spacing: 0.26px;
    color: var(--plan-color);
  }
}

.headerLeftContainer {
  display: flex;
  align-items: center;
}

.headerRightContainer {
  display: flex;
  align-items: flex-start;
}

.trialConnector {
  margin: 0 7px;
  color: var(--dark-40);
}

.paymentInfo {
  margin-top: 8px;
  color: var(--dark-80);

  @include sm-sohne;
}

.originalPrice {
  text-decoration: line-through;
  color: var(--dark-40);
}

.amount {
  font-weight: 700;
}

.planContainer {
  margin-bottom: 20px;
}

.tablesContainer {
  display: flex;
}

.divider {
  background-color: var(--dark-4);
  width: 2px;
  margin: 7px 10px;
}

.upgradeButtonContainer {
  position: relative;
  margin-right: 10px;
}

.pricePillContainer {
  position: absolute;
  top: -10px;
  right: 4px;
}

.appStoreMessage {
  margin-top: 20px;
}
